module.exports = __webpack_public_path__ + "img/solo2_9854HD.2ec48371.jpg";